import styled from "styled-components";

const PersnalSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  background: -webkit-linear-gradient(
    to right,
    rgba(161, 196, 253, 1),
    rgba(194, 233, 251, 1)
  );
  display: flex;
  flex-direction: column;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  /* .bg-indigo {
  background-color: #4835d4;
} */
  .inner-container {
    /* height: 100vh; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
  }
  .personal-detail {
    width: 95vw;
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .inner-content {
    width: 45%;
  }
  .official-details {
    padding: 16px;
    width: 40vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 11.5px;
  }
  .account-details {
    width: 95vw;
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .form-details {
    width: 100%;
    display: flex;
  }
  .buttons-class {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    gap: 2rem;
    padding: 1rem;
  }
`;
export default PersnalSc;
